import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import { SlideIn, SubmitButton } from 'components';
import {
  DateOfBirthQuestion,
  SegmentedControlOptions,
  SegmentedControlQuestion,
} from 'scenes/common/components/Questions';
import {
  MotorFlowType,
  DriverGender,
  MotorFunnelState,
  MotorFullPageProps,
} from 'scenes/motor/types';
import { getGender, getDob } from 'scenes/motor/selectors';

const GENDER = 'gender';
const DOB = 'dob';

const DRIVER_GENDER_OPTIONS: SegmentedControlOptions<
  DriverGender,
  DriverGender
> = [
  { label: DriverGender.Male, value: DriverGender.Male },
  { label: DriverGender.Female, value: DriverGender.Female },
];

const MIN_AGE = 16;
const MAX_AGE = 100;

const getQuestion = (flowType: MotorFlowType): string => {
  switch (flowType) {
    case MotorFlowType.QuoteDetails:
      return 'What is the gender of the main driver?';
    case MotorFlowType.AddPolicyHolder:
      return 'What is the gender of the additional policy holder?';
    case MotorFlowType.AddDriver:
      return 'What is the gender of the additional driver?';
    default:
      return 'What is the gender of the driver?';
  }
};

const getGenderAndDob = (state: MotorFunnelState) => ({
  gender: getGender(state),
  dob: getDob(state),
});

const GenderAndDateOfBirthStep: FunctionComponent<MotorFullPageProps> = ({
  flowType,
  funnelState,
  onNext,
}) => {
  const {
    formState: hooksForm,
    handleSubmit,
    errors,
    control,
    watch,
  } = useForm({
    mode: 'onChange',
  });
  const { gender, dob } = getGenderAndDob(funnelState);
  const watchedGender = watch(GENDER, gender);

  return (
    <form onSubmit={handleSubmit(onNext)} autoComplete="on">
      <SegmentedControlQuestion
        options={DRIVER_GENDER_OPTIONS}
        stateKey={GENDER}
        question={getQuestion(flowType)}
        defaultValue={gender}
        control={control}
        errors={errors}
      />

      {Boolean(watchedGender) && (
        <SlideIn>
          <DateOfBirthQuestion
            question="What is their date of birth?"
            minAge={MIN_AGE}
            maxAge={MAX_AGE}
            entityType={
              flowType === MotorFlowType.AddPolicyHolder
                ? 'policy holder'
                : 'driver'
            }
            defaultValue={dob}
            stateKey={DOB}
            errors={errors}
            control={control}
          />
        </SlideIn>
      )}
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
    </form>
  );
};

export default GenderAndDateOfBirthStep;
